import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthGuard, I18nModule, provideConfig } from '@spartacus/core';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { KbDirectivesModule } from 'src/app/directives/kb-directives.module';
import { KbCustomerIdDropdownModule } from '../../kb-MyOwnPartNumbers/customer-id-drop-down/customer-id-drop-down.module';
import { KbMyAccountLeftSideNavModule } from '../../my-account-left-sidenav/my-account-left-sidenav.module';
import { KbOpenPositionTableModule } from '../kb-open-position-table/kb-open-position-table.module';
import { KbOpenPositionComponent } from './kb-open-position.component';
import { SecureGuard } from 'src/app/services/Guards/secure.service';

@NgModule({
  imports: [
    CommonModule,
    KbMyAccountLeftSideNavModule,
    I18nModule,
    KbCustomerIdDropdownModule,
    BsDatepickerModule,
    KbOpenPositionTableModule,
    ReactiveFormsModule,
    KbDirectivesModule
  ],
  declarations: [KbOpenPositionComponent],
  exports: [KbOpenPositionComponent],
  providers: [
    provideConfig({
      cmsComponents: {
        OpenPositionFlexComponent: {
          component: KbOpenPositionComponent,
          guards: [SecureGuard, AuthGuard],
        },
      },
    }),
  ],
})
export class KbOpenPositionModule {}
